module.exports = __webpack_public_path__ + "img/bd-nova-sor.669415e7.png";